import {BarrierType} from 'src/services/api/endpoints/ObjectEndpoint'
import axios from './_axios'
import {AxiosResult} from './_types'

const prefix = process.env.REACT_APP_OBJECTS_BASE_URL

type CreateCoordinates = {
  x: number
  y: number
  reference: number
}

export type Coordinate = {
  id: number
  x: number
  y: number
  reference: number
  interestAreaId: number
}

export type BarrierTypeResponse = {
  id: number
  cameraConfigurationId: number
  coordinates: Coordinate[]
  name: string
  type: BarrierType
}

export class CreateBarrier {
  cameraId: number
  coordinates: CreateCoordinates[]
  name: string
  type: BarrierType

  constructor(cameraId: number, coordinates: CreateCoordinates[], name: string, type: BarrierType) {
    this.cameraId = cameraId
    this.coordinates = coordinates
    this.name = name
    this.type = type
  }
}

type UpdateBarrier = {
  coordinates: CreateCoordinates[]
  name?: string
  id: number
}

export class BarriersEndpoint {
  async getBarriers(params: {cameraId: number}): Promise<AxiosResult<BarrierTypeResponse[]>> {
    return axios.get(`${prefix}/barriers`, {params})
  }

  async createBarrier(body: CreateBarrier): Promise<AxiosResult<BarrierTypeResponse>> {
    return axios.post(`${prefix}/barriers`, body)
  }

  async updateBarrier(body: UpdateBarrier): Promise<AxiosResult<BarrierTypeResponse>> {
    return axios.patch(`${prefix}/barriers`, body)
  }

  async deleteBarrier(interestAreaId: number): Promise<AxiosResult<any>> {
    return axios.delete(`${prefix}/barriers/${interestAreaId}`)
  }
}
